<template>
  <div>
      <button class="add-brand-button" @click="showModalAddBranded">ADD NEW BRANDED ARTICLE</button>
      <modal-branded v-if="showBrandedModal" :modal.sync="showBrandedModal" :passedValue="probTotal"></modal-branded>
      <table style="width:100%">
        <tr>
          <th>ARTICLE SLUG</th>
          <th>ACTIVE</th>
          <th>LOCATION</th>
          <th>TARGETED PAGEVIEWS</th>
          <th>CURRENT PAGEVIEWS</th>
          <th 
            @click="sort('startDate')" 
            class="sortable" 
            :class="order.startDate !== null ? (order.startDate ? 'asc' : 'desc'): ''"
            >
            <div>
              CAMPAIGN START DATE
              <svg class="up-down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"/></svg>
              <svg class="up" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
              <svg class="down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
            </div>
          </th>
          <th 
            @click="sort('endDate')" 
            class="sortable" 
            :class="order.endDate !== null ? (order.endDate ? 'asc' : 'desc'): ''"
            >
            <div>
            CAMPAIGN END DATE
            <svg class="up-down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"/></svg>
            <svg class="up" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
            <svg class="down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
            </div>
          </th>
          <th>PROBABILITY OF SURFACING</th>
          <th>% PV TARGET LIKELY TO BE ACHIEVED</th>
          <th></th>
          <th></th>
        </tr>
        <tr v-for="(item, key) in brandedData" :key="key">
          <td>{{ item.data.url }}</td>
          <td>{{ item.data.active }}</td>
          <td>{{item.data.location ? item.data.location : 'N/A'}}</td>
          <td>{{ item.data.pageviews }}</td>
          <td>{{ item.data.currentPageviews }}</td>
          <td>{{ item.data.startDate }}</td>
          <td>{{ item.data.endDate }}</td>
          <td class="probability">{{ item.data.probability }}<span v-if="item.data.location !== 'All States' && item.data.location !== undefined "> {{adjustProbForState(item.data)}}</span> </td>
          <td>{{ brandedDataCalculatedDelivery[key] ? `${brandedDataCalculatedDelivery[key]} %` : "N/A"}}</td>
          <td><modal-editbrand :passedItem="item"></modal-editbrand></td>
          <td><modal-delbrand :passedItem="item"></modal-delbrand></td>
        </tr>
      </table>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;
import ModalBranded from "../modals/branded/ModalBranded.vue";
import ModalEditbrand from "../modals/branded/ModalEditbrand.vue";
import ModalDelbrand from "../modals/branded/ModalDelbrand.vue";

export default {
  components: {ModalBranded, ModalEditbrand, ModalDelbrand},
  data() {
    firestore = firebase.firestore();
    return {
      newBrand: {
        endDate: new Date()
      },
      brandedData: [],
      showBrandedModal:false,
      probTotal: 0,
      order: {
        endDate: null,
        startDate: null,
      },
      user_populations: { "New South Wales": 32, Victoria: 29.21, Queensland: 19.94, "Western Australia": 8.47, "South Australia": 7.33 }
    };
  },
  // firestore() {
  //   return {
  //     brandedData: firestore.collection("brandedArticles")
  //   };
  // },
  computed: {
    brandedDataCalculatedDelivery() {
      return this.brandedData.map(vt => this.calculateDelivery(vt.data));
    }
  },
  mounted: async function() {
    //console.log(this.brandedData);
    var currentDate = Math.floor(Date.now() / 1000);
    var newDate = new Date(this.newBrand.endDate).getTime() / 1000;
    var noOfDays = Math.floor((newDate - currentDate )/ 86400);
    this.brandedSubscribe = firestore.collection("brandedArticles").onSnapshot((snap) => {
      this.brandedData = snap.docs.map(doc => {
          return { id: doc.id, data: doc.data() }
      });
    });

  },
  methods: {
    sort: function(column) {
      const order = this.order[column] ? 'desc' : 'asc';
      // Using firebase's 'desc' or'asc' might cause some rows to disappear if it is missing a data key newer data should have all the proper keys but if this becomes a big issue use sort method instead
      this.brandedSubscribe();

      this.brandedSubscribe = firestore.collection("brandedArticles").orderBy(column, order).onSnapshot((snap) => {
        this.brandedData = snap.docs.map(doc => {
            return { id: doc.id, data: doc.data() }
        });
      });

      this.order[column] = !this.order[column];
      // Reset all other columns
      Object.keys(this.order).forEach((item) => {
        console.log("loop");
        if(item !== column){
          this.order[item] = null;
        };
      });

    },
    showModalAddBranded: function() {
      //calculate the current probability total
      var useArray = this.brandedData;
      var proCount = 0;
      useArray.forEach(function (arrayItem) {
        if(arrayItem.active == true){
          proCount= arrayItem.probability + proCount
        }
      });
      this.probTotal = proCount;
      this.showBrandedModal = true;
    },
    getEma: function (pageViewHistory) {
      if(!pageViewHistory) {
        return null;
      }
      var newArray = [];
      pageViewHistory.forEach((hist) => {
        newArray.push(hist);
      });
      newArray.sort((a,b) => {
        return a.timestamp > b.timestamp;
      })

      var previous = "unset";
      var values = [];

      newArray.forEach((data) => {
        if(previous != "unset") {
          values.push({"pageviews": data.pageviews - previous, "probability": data.probability});
        }
        previous = data.pageviews;
      });
 
      var count = 0;
      var dayCount = 0;
      var probability = 0;
      var totalValues = [];
      values.forEach((value) => {
        if(count < 12) {
          dayCount+=value.pageviews;
          probability += value.probability;
          count++;
        } else {
          totalValues.push((dayCount) / (probability / 12));
          dayCount = value.pageviews;
          probability = value.probability;
          count= 0;
        }
      });
      var getEMA = (a,r) => a.reduce((p,n,i) => i ? p.concat(2*n/(r+1) + p[p.length-1]*(r-1)/(r+1)) : p, [a[0]]);

      var range = Math.round(totalValues.length / 4);
      if(range < 2) range = 2;
      var ema = getEMA(totalValues, 2);

      return ema[ema.length - 1];

    },
    calculateDelivery: function(item, probability = false) {
      console.log(item);
      if(!item.active || !item.pageViewHistory || item.pageViewHistory.length < 24){
        return false;
      }

      const emaRate = this.getEma(item.pageViewHistory);

      const currentDate = Math.floor(Date.now() / 1000);
      const newDate = new Date(item.endDate).getTime() / 1000;
      const startDate = item.pageViewHistory[0].timestamp.getTime() / 1000;

      const daysLeft = Math.floor((newDate - currentDate ) / 86400);
      const daysPast = Math.floor(( currentDate - startDate ) / 86400);
      const expectedPageViewsPerDay = (emaRate * (probability ? probability : item.probability)) * 0.9; // Pessimism
      const likelyTotal = item.pageviews ?  (daysLeft * expectedPageViewsPerDay) + item.pageviews : daysLeft * expectedPageViewsPerDay;
      const likelyPercent = Math.round(likelyTotal / item.pageviews * 100);
      return likelyPercent;
      // expectedPageViewsPerDay and pvPerDay are almost the same thing but have to deal with the fact that there may not be a startDay or ema. Will need to think of better names.
      // const expectedPageViewsPerDay = daysPast > 0 ? item.currentPageviews/daysPast : item.currentPageviews;
      // const pvPerDay = ema ? ema : expectedPageViewsPerDay;
      // const likelyTotal = item.otherPageviews ?  (daysLeft * pvPerDay) + item.otherPageviews : daysLeft * pvPerDay;
      // const likelyPercent = Math.round(likelyTotal / item.pageviews * 100);
      // return likelyPercent;
    },
    recommendedProbability: function(item,index) {
      if(!item.active){
        return false;
      }
      let recommendedProbability = 0;
      var calculateDelivery = this.brandedDataCalculatedDelivery[index];
      if (calculateDelivery) {
        recommendedProbability =  100/calculateDelivery;
      } else {
        return false;
      }

      var target = Math.round((recommendedProbability * item.probability) * 100)/100;
      if(this.calculateDelivery(item, target) < 100) target =  Math.round((target + 0.01) * 100)/100;
      console.log("loop", index);

      return target;
    },
    updateProbability: function(item,index) {
      const newProbability = this.recommendedProbability(item,index);
      firestore.collection("brandedArticles").where("url", "==", `${item.url}`).get().then((snap) => {
        const data = snap.docs[0];
        firestore.collection("brandedArticles").doc(data.id).update({
          probability: newProbability
        }).then(() => {

        });
      })
    },
    adjustProbForState: function(item) {
      const location_amount = (this.user_populations[item.location] * 100) * (item.probability / 100);
      const difference = ((item.probability / 100) * 10000) / location_amount;
      return `(State Adjustment: ${(item.probability * difference).toFixed(2)})` ;
    }
  }
};
</script>
<style scoped>
table {
  margin-top:20px;
}
th {
  background-color: #f1f1f1;
  color:#000;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 15px;
  text-align: left;
}
.add-brand-button {
  margin-top:20px;
  background-color: #ff5252;
  height:40px;
  padding:10px;
}
.probability span {
  float: right;
}

.sortable {
  cursor: pointer;
}

.desc .up-down, .asc .up-down {
  display: none;
}

.desc .down, .asc .up {
  display: inline;
}

.up, .down {
  display: none;
}

svg {
  height: 30px;
  width: 30px;
  margin: auto 0;
}

th > div {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// branded.vue?52af5265